import React from 'react';
import {TypeImplementation} from '@packages/systems/wfdl';
import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';

import {TEnum} from '@packages/systems/wfdl-ast';
import {iconName, pluginName, qualify} from '@packages/systems/wfdl-Qualified';

// A "TriStateBoolean" is a boolean that can also be "Any",
// modeled as an enum of true/false/any
export const TriStateBoolean = TypeImplementation.Alias({
  type: TEnum({
    true: 'Yes',
    false: 'No',
    any: 'Either',
  }),
  render: ({expr, dispatch}) => {
    return <ExpressionEditor expression={expr} dispatch={dispatch} />;
  },
  icon: TypeImplementation.IconByName(
    qualify(pluginName('Basic'), iconName('TriStateBoolean'))
  ),
  system: {displayName: 'Boolean filter'},
});
